// @ts-nocheck
import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    GetProductByIdApiV2Parameter,
    GetProductVariantChildApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import loadVariantChild from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChild";
import loadVariantChildren from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { AnyAction } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
} from "@toolkit/Modules/client-framework/HandlerCreator";

interface Parameter {
    productId?: string;
    variantId?: string;
}

interface Props {
    apiParameter: GetProductByIdApiV2Parameter | GetProductVariantChildApiV2Parameter;
    variantChildren?: ProductModel[] | null;
    product?: ProductModel;
    productInfo?: ProductInfo;
}

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginSetProduct: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductSelector/BeginSetProduct",
    });
    props.dispatch({ type: "Store/Pages/buyingList/setIsLoading", isLoading: true } as unknown as AnyAction);
};

export const PopulateApiParameter: HandlerType = props => {
    if (props.parameter.variantId && props.parameter.productId) {
        props.apiParameter = {
            id: props.parameter.variantId,
            variantParentId: props.parameter.productId,
            expand: ["detail"],
        };
    } else if (props.parameter.productId) {
        props.apiParameter = {
            id: props.parameter.productId,
            expand: ["detail", "variantTraits"],
        };
    }
};

export const RequestDataFromApi: HandlerType = async props => {
    const { apiParameter } = props;

    if (!apiParameter) {
        return;
    }

    if (apiParameter) {
        props.product = getProductState(props.getState(), apiParameter.id).value;

        if (
            !props.product ||
            !props.product.detail ||
            (props.product.isVariantParent && !props.product.variantTraits)
        ) {
            if (props.parameter.variantId) {
                props.product = await executeAwaitableHandlerChain(
                    loadVariantChild,
                    props.apiParameter as GetProductVariantChildApiV2Parameter,
                    props,
                );
            } else {
                props.product = await executeAwaitableHandlerChain(loadProduct, props.apiParameter, props);
            }
        }
    }
};

export const RequestVariantChildrenFromApi: HandlerType = async props => {
    if (!props.product?.variantTraits || props.product.variantTraits.length === 0) {
        return;
    }

    props.variantChildren = getVariantChildrenDataView(props.getState(), props.product.id).value;
    if (!props.variantChildren) {
        props.variantChildren = await executeAwaitableHandlerChain(
            loadVariantChildren,
            { productId: props.product.id },
            props,
        );
    }
};

export const ValidateProduct: HandlerType = props => {
    if (!props.product) {
        return;
    }
    if (props.product?.isVariantParent) {
        props.dispatch({
            type: "Components/ProductSelector/OpenVariantModal",
            productId: props.product.id,
        });
        props.dispatch({ type: "Store/Pages/buyingList/setIsLoading", isLoading: false } as unknown as AnyAction);
        return false;
    }
    props.productInfo = createFromProduct(props.product);
};

export const DispatchCompleteSetProduct: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductSelector/CompleteSetProduct",
        productInfo: props.productInfo,
    });
    props.dispatch({ type: "Store/Pages/buyingList/setIsLoading", isLoading: false } as unknown as AnyAction);
};

export const chain = [
    DispatchBeginSetProduct,
    PopulateApiParameter,
    RequestDataFromApi,
    RequestVariantChildrenFromApi,
    ValidateProduct,
    DispatchCompleteSetProduct,
];

const setBuyingListProduct = createHandlerChainRunner(chain, "SetBuyingListProduct");
export default setBuyingListProduct;
